import axios from "axios";

export const API_URL = process.env.REACT_APP_API_URL;

export const getProperties = async () =>{
    const res = await fetch(`${API_URL}/inmogar/admin/properties`);
  return await res.json();
};

export const createProperty = (data) =>
  axios.post(`${API_URL}/inmogar/admin/properties`, data);

export const deleteProperty = (id) =>
  axios.delete(`${API_URL}/inmogar/admin/properties/${id}`);
